export default "__VITE_ASSET__BFRcYAIs__"